// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { Platform, StyleSheet } from 'react-native';
import appColors from '@/theme/colors';

const blockShadow = Platform.select({
  web: { boxShadow: '0px 2px 8px rgba(0,0,0,0.14)' },
  default: {
    shadowColor: '#000000',
    shadowOpacity: 0.14,
    shadowRadius: 6,
    shadowOffset: { width: 0, height: 2 },
  },
});

export const styles = StyleSheet.create({
  scroll: {
    backgroundColor: '#011806',
  },
  compactScroll: {
    flex: 1,
  },
  compactScrollContent: {
    flexGrow: 1,
    paddingBottom: 180,
  },
  scrollContent: {
    flexGrow: 1,
  },
  compactList: {
    gap: 10,
    marginTop: 8,
    backgroundColor: 'transparent',
  },
  compactRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 12,
    backgroundColor: appColors.surface.base,
    borderWidth: 1,
    borderColor: appColors.border.default,
  },
  compactInfoColumn: {
    flex: 1,
    marginRight: 10,
    backgroundColor: 'transparent',
  },
  compactNameRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    flexWrap: 'wrap',
    backgroundColor: 'transparent',
  },
  compactNameLine: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
    flexShrink: 1,
    backgroundColor: 'transparent',
  },
  compactNameBlock: {
    width: 200,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    backgroundColor: 'transparent',
  },
  compactAvatarWrap: {
    width: 28,
    height: 28,
    borderRadius: 10,
    overflow: 'hidden',
    borderWidth: 0,
    borderColor: 'transparent',
    backgroundColor: 'transparent',
  },
  compactAvatar: {
    width: '100%',
    height: '100%',
  },
  compactName: {
    color: appColors.text.heading,
    fontSize: 16,
    fontWeight: '700',
    flexShrink: 1,
  },
  roundPlacementBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
    backgroundColor: 'transparent',
  },
  roundPlacementMedal: {
    fontSize: 13,
  },
  compactLeaderTrophy: {
    color: '#9fcc15',
  },
  compactHandicapRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    backgroundColor: 'transparent',
  },
  compactHandicapText: {
    color: appColors.text.secondary,
    fontSize: 14,
    fontWeight: '600',
  },
  compactScoreButton: {
    width: 118,
    height: 52,
    borderRadius: 0,
    backgroundColor: 'transparent',
    borderWidth: 0,
    borderColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    shadowColor: '#e9eeea',
    shadowOpacity: 0,
    shadowRadius: 0,
    shadowOffset: { width: 0, height: 0 },
    elevation: 0,
  },
  compactScoreButtonImage: {
    width: '100%',
    height: '100%',
  },
  compactScoreActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: 'transparent',
  },
  compactScoreMysteryIcon: {
    width: 20,
    height: 20,
  },
  compactScoreButtonText: {
    position: 'absolute',
    width: '100%',
    textAlign: 'center',
    lineHeight: 52,
    color: '#9fcc15',
    fontFamily: 'Sanchez',
    fontWeight: '800',
    fontSize: 18,
    textShadowColor: 'rgba(0, 0, 0, 0.45)',
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 3,
  },
  compactScoreButtonTextPlaceholder: {
    color: '#9fcc15',
  },
  compactScoreHazardBadges: {
    position: 'absolute',
    right: 6,
    top: 6,
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  compactScoreHazardBadge: {
    width: 20,
    height: 20,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  compactScoreHazardBadgeWater: {
    backgroundColor: '#A1D493',
  },
  compactScoreHazardBadgeSand: {
    backgroundColor: '#8b5a2b',
  },
  compactScoreHazardBadgeThreeputt: {
    backgroundColor: '#F5F5DC',
  },
  compactScoreHazardBadgeOther: {
    backgroundColor: '#9fcc15',
  },
  compactScoreHazardBadgeTextBase: {
    fontSize: 9,
    fontWeight: '800',
    lineHeight: 9,
  },
  compactScoreHazardBadgeTextLight: {
    color: '#F5F5DC',
  },
  compactScoreHazardBadgeTextDark: {
    color: '#F5F5DC',
  },
  compactStablefordText: {
    color: '#4ade80',
    fontWeight: '700',
    fontSize: 18,
    minWidth: 16,
    textAlign: 'center',
  },
  scorePopupGrid: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
    marginTop: 6,
    marginLeft: 0,
    paddingBottom: 18,
    width: 338,
      left:10,
    overflow: 'visible'
  },
  scorePopupHazardColumn: {
    width: 74,
    alignItems: 'center',
    gap: 10,
    paddingTop: 34,
    marginLeft: 0,
    backgroundColor: 'transparent',
  },
  scorePopupHazardButton: {
    width: 126,
    minHeight: 78,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    marginLeft: 38,
    backgroundColor: 'transparent',
  },
  scorePopupHazardLabel: {
    color: '#f6e5c0',
    fontSize: 10,
    lineHeight: 11,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  scorePopupHazardControlRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    backgroundColor: 'transparent',
  },
  scorePopupHazardAdjustButton: {
    width: 24,
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#8d6232',
    backgroundColor: 'rgba(59, 37, 20, 0.75)',
  },
  scorePopupHazardAdjustText: {
    color: '#f6e5c0',
    fontSize: 18,
    lineHeight: 18,
    fontWeight: '800',
    textAlign: 'center',
  },
  scorePopupHazardIconWrap: {
    width: 52,
    height: 52,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  scorePopupChipInToggle: {
    width: 56,
    height: 56,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 28,
    borderWidth: 2,
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    opacity: 0.55,
  },
  scorePopupChipInToggleSelected: {
    borderColor: '#A1D493',
    backgroundColor: 'rgba(161, 212, 147, 0.18)',
    opacity: 1,
  },
  scorePopupChipInCheck: {
    position: 'absolute',
    right: 2,
    bottom: 2,
    color: '#A1D493',
    fontSize: 18,
    fontWeight: '800',
    textShadowColor: 'rgba(0, 0, 0, 0.75)',
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 2,
  },
  scorePopupHazardIcon: {
    width: 52,
    height: 52,
    position: 'relative',
  },
  scorePopupHazardCount: {
    minWidth: 18,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: '#F5F5DC',
    fontSize: 24,
    lineHeight: 52,
    fontWeight: '800',
    textShadowColor: 'rgba(0, 0, 0, 0.75)',
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 2,
  },
  scorePopupMysteryButton: {
    width: 74,
    minHeight: 72,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    paddingVertical: 4,
    borderWidth: 2,
    borderColor: 'transparent',
    borderRadius: 8,
  },
  scorePopupMysteryButtonSelected: {
    borderColor: '#f6e5c0',
    backgroundColor: 'rgba(246, 229, 192, 0.18)',
  },
  scorePopupMysteryIcon: {
    width: 34,
    height: 34,
  },
  scorePopupMysteryText: {
    color: '#f6e5c0',
    fontSize: 10,
    lineHeight: 12,
    textAlign: 'center',
    width: '100%',
    paddingHorizontal: 2,
  },
  scorePopupMysterySetupButton: {
    width: 126,
    minHeight: 78,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    marginLeft: 38,
    backgroundColor: 'transparent',
  },
  scorePopupLeftColumn: {
    width: 200,
    alignItems: 'flex-start',
    gap: 0,
    backgroundColor: 'transparent',
    position: 'relative',
    zIndex: 300,
    elevation: 300,
    paddingTop: 30,
    overflow: 'visible'
  },
  scorePopupTopPlateImage: {
    width: 430,
    height: 85,
    marginLeft: -45,
    position: 'absolute',
    top: -4,
    left: 0,
    zIndex: 400,
    elevation: 400,
  },
  scorePopupTopPlateText: {
    position: 'absolute',
    top: 18,
    left: 124,
    zIndex: 401,
    elevation: 401,
    color: '#f6e5c0',
    fontSize: 32,
    fontFamily: 'Sanchez',
    fontWeight: '800',
    textShadowColor: 'rgba(0, 0, 0, 0.45)',
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 3,
  },
  scorePopupRailImage: {
    width: 60,
    height: 500,
    position: 'absolute',
    top: 44,
    left: 59,
    backgroundColor: 'transparent',
    borderRadius: 0,
    zIndex: 320,
    elevation: 320,
  },
  scorePopupRailMarksColumn: {
    position: 'absolute',
    top: 102,
    left: 22,
    zIndex: 360,
    elevation: 360,
    gap: 0,
  },
  scorePopupRailMarkIcon: {
    width: 36,
    height: 36,
    left: 48,
    backgroundColor: 'transparent',
    borderWidth: 0,
    zIndex: 340,
    elevation: 340,
    marginTop: -16,
  },
  scorePopupRailMarkSlot: {
    width: 54,
    height: 59,
    backgroundColor: 'transparent',
    borderWidth: 0,
    position: 'relative',
  },
  scorePopupRailParRing: {
    width: 32,
    height: 32,
    position: 'absolute',
    top: -15,
    left: 50,
    backgroundColor: 'transparent',
    borderWidth: 2,
    borderColor: '#A06A3A',
    borderRadius: 999,
    zIndex: 530,
    elevation: 130,
  },
  scorePopupRailPegIcon: {
    width: 80,
    height: 80,
    position: 'absolute',
    top: -32,
    left: 27,
    zIndex: 540,
    elevation: 140,
  },
  scorePopupRailMarkIconFirst: {
    marginTop: 0,
  },
  scorePopupRows: {
    flex: 0,
    width: 124,
    marginLeft: -96,
    gap: 10,
    marginTop: 80,
    backgroundColor: 'transparent',
    position: 'relative',
    zIndex: 10,
    elevation: 10,
  },
  scorePopupButton: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 124,
    height: 49,
    marginLeft: 0,
    overflow: 'hidden',
  },
  scorePopupButtonPar: {
    opacity: 0.98,
  },
  scorePopupButtonSelected: {
    borderWidth: 2,
    borderColor: '#d4af37',
    borderRadius: 6,
    shadowColor: '#d4af37',
    shadowOpacity: 0.5,
    shadowRadius: 4,
    shadowOffset: { width: 0, height: 0 },
  },
  scorePopupButtonImage: {
    width: 124,
    height: 49,
    position: 'absolute',
    top: 0,
    left: 0,
    pointerEvents: 'none',
  },
  scorePopupButtonText: {
    color: '#f6e5c0',
    fontSize: 30,
    fontFamily: 'Sanchez',
    fontWeight: '800',
    position: 'absolute',
    top: 0,
    left: -2,
    width: 124,
    textAlign: 'center',
    lineHeight: 44,
    textShadowColor: 'rgba(0, 0, 0, 0.45)',
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 3,
    pointerEvents: 'none',
  },
  scorePopupButtonTextPar: {
    color: '#ffe09a',
  },
  scorePopupEightPlusOverlay: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 30,
    justifyContent: 'center',
    alignItems: 'center',
  },
  scorePopupEightPlusBackdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(34, 20, 8, 0.6)',
  },
  scorePopupEightPlusCard: {
    minWidth: 140,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#8d6232',
    backgroundColor: '#3b2514',
    paddingVertical: 8,
    paddingHorizontal: 8,
    gap: 6,
  },
  scorePopupEightPlusOption: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#9a6f3f',
    backgroundColor: '#5a3a22',
    paddingVertical: 8,
    paddingHorizontal: 12,
    alignItems: 'center',
  },
  scorePopupEightPlusOptionText: {
    color: '#f6e5c0',
    fontSize: 16,
    fontWeight: '700',
  },
  pageBackground: {
    flex: 1,
    width: '100%',
    backgroundColor: appColors.background.app,
    position: 'relative',
  },
  container: {
    padding: 12,
    gap: 8,
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  containerCompact: {
    justifyContent: 'flex-start',
  },
  compactRoot: {
    flex: 1,
    position: 'relative',
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    width: '100%',
    justifyContent: 'space-between',
    backgroundColor: 'transparent',
  },
  holeTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flex: 1,
    backgroundColor: 'transparent',
  },
  holeTitleSign: {
    minWidth: 96,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 22,
    paddingVertical: 10,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: '#2D6438',
    backgroundColor: '#12381B',
    ...Platform.select({
      web: { boxShadow: 'inset 0px 10px 18px rgba(161,212,147,0.2), 0px 3px 10px rgba(0,0,0,0.28)' },
      default: {
        shadowColor: '#000000',
        shadowOpacity: 0.28,
        shadowRadius: 8,
        shadowOffset: { width: 0, height: 2 },
      },
    }),
  },
  holeTitleNumber: {
    fontSize: 34,
    fontWeight: '800',
    letterSpacing: 0.8,
    color: '#F5F5DC',
    textAlign: 'center',
    ...Platform.select({
      web: { fontFamily: 'Newsreader, Playfair Display, Georgia, serif' },
      default: { fontFamily: 'serif' },
    }),
    backgroundColor: 'transparent',
  },
  mysteryPrizeIcon: {
    width: 23,
    height: 23,
  },
  mysteryWinnerIcon: {
    width: 16,
    height: 16,
  },
  mysteryPrizeText: {
    color: appColors.text.secondary,
    fontSize: 13,
    textAlign: 'center',
  },
  mysteryPrizeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    backgroundColor: 'transparent',
  },
  mysteryPrizeSetupButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    paddingVertical: 6,
    paddingHorizontal: 14,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: appColors.border.strong,
    backgroundColor: appColors.background.panelAlt,
  },
  mysteryPrizeSetupButtonText: {
    color: appColors.text.primary,
    fontSize: 13,
    fontWeight: '600',
  },
  meta: {
    textAlign: 'center',
    color: '#8FA08B',
  },
  holeInfoBlock: {
    alignItems: 'center',
    gap: 4,
    padding: 10,
    borderRadius: 12,
    overflow: 'hidden',
    backgroundColor: 'transparent',
  },
  holeInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    backgroundColor: 'transparent',
  },
  holeInfoBadge: {
    paddingVertical: 8,
    paddingHorizontal: 18,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: appColors.border.default,
    backgroundColor: appColors.surface.alt,
    color: appColors.text.secondary,
    fontWeight: '700',
    fontSize: 13,
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  holeInfoName: {
    color: appColors.text.heading,
    fontWeight: '700',
    textAlign: 'center',
  },
  holeInfoDescription: {
    color: appColors.text.secondary,
    textAlign: 'center',
    lineHeight: 18,
  },
  detailsToggle: {
    marginTop: 4,
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: appColors.border.default,
    backgroundColor: appColors.surface.alt,
  },
  detailsToggleText: {
    color: appColors.text.secondary,
    fontWeight: '600',
  },
  metaRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 12,
  },
  subtitle: {
    textAlign: 'center',
    fontSize: 16,
    color: appColors.text.heading,
  },
  error: {
    textAlign: 'center',
    color: '#ff7b7b',
  },
  scoreboard: {
    padding: 8,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: appColors.border.default,
    backgroundColor: appColors.surface.base,
    gap: 8,
    flexDirection: 'column',
    ...blockShadow,
  },
  gameResultsFrame: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: appColors.border.default,
    backgroundColor: appColors.surface.base,
    padding: 6,
  },
  scoreboardTitle: {
    fontSize: 15,
    fontWeight: '700',
    color: appColors.text.heading,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
  },
  scoreboardColumnsHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 2,
    backgroundColor: 'transparent',
  },
  scoreboardNameHeaderSpacer: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  scoreboardNameHeader: {
    flex: 1,
    fontSize: 16,
    fontWeight: '700',
    color: appColors.text.heading,
    backgroundColor: 'transparent',
  },
  scoreboardScoreColumnHeader: {
    width: 54,
    textAlign: 'right',
    fontSize: 11,
    fontWeight: '700',
    color: appColors.text.secondary,
    textTransform: 'uppercase',
  },
  scoreboardEmpty: {
    color: appColors.text.secondary,
    fontSize: 13,
  },
  scoreboardRow: {
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 4,
    backgroundColor: 'transparent',
  },
  scoreboardNameRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    flexShrink: 1,
    backgroundColor: 'transparent',
  },
  scoreboardName: {
    fontWeight: '600',
    color: appColors.text.heading,
  },
  scoreboardValue: {
    width: 54,
    textAlign: 'right',
    fontWeight: '700',
    color: '#A1D493',
    backgroundColor: 'transparent',
  },
  scoreboardScores: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
    minWidth: 116,
    backgroundColor: 'transparent',
  },
  scoreboardValueDetails: {
    textDecorationLine: 'underline',
  },
  gameResultsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    width: '100%',
    paddingVertical: 2,
    backgroundColor: 'transparent',
  },
  modalBackdrop: {
    flex: 1,
    backgroundColor: appColors.accent.overlay,
    justifyContent: 'center',
    padding: 14,
  },
  modalCard: {
    backgroundColor: appColors.surface.base,
    borderRadius: 16,
    padding: 20,
    borderWidth: 1,
    borderColor: appColors.border.default,
    gap: 12,
  },
  mysteryModalFrame: {
    backgroundColor: appColors.surface.elevated,
    borderRadius: 18,
    borderWidth: 2,
    borderColor: appColors.border.strong,
    padding: 6,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.4,
    shadowRadius: 12,
    elevation: 10,
  },
  mysteryModalInner: {
    backgroundColor: appColors.surface.base,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: appColors.border.strong,
    padding: 18,
    gap: 12,
  },
  scoreModalCard: {
    backgroundColor: '#5F7A56',
    borderColor: '#1F351E',
    borderWidth: 2,
    borderRadius: 12,
    width: 560,
    maxWidth: '100%',
    paddingHorizontal: 4,
    paddingVertical: 2,
    marginBottom: -10,
  },
  scoreModalBackdrop: {
    justifyContent: 'flex-end',
  },
  scoreModalBackdropTop: {
    justifyContent: 'flex-start',
    paddingTop: 58,
  },
  scorePopupScroll: {
    width: '100%',
  },
  scorePopupScrollContent: {
    paddingBottom: 8,
  },
  scorePopupTitle: {
    color: '#F5F5DC',
    fontSize: 20,
    marginTop: 8,
    textShadowColor: 'rgba(0, 0, 0, 0.45)',
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 1,
  },
  scorePopupSubtitle: {
    color: '#F5F5DC',
    fontSize: 13,
    fontWeight: '700',
    textAlign: 'center',
    marginTop: 4,
    marginBottom: 2,
  },
  scorePopupCloseButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    width: 36,
    height: 36,
    minWidth: 36,
    paddingHorizontal: 0,
    paddingVertical: 0,
    marginTop: 0,
    zIndex: 4,
    elevation: 4,
  },
  scorePopupCloseButtonText: {
    fontSize: 18,
    lineHeight: 18,
    fontWeight: '800',
    letterSpacing: 0,
    textTransform: 'none',
  },
  modalTitle: {
    color: appColors.text.heading,
    fontSize: 18,
    fontWeight: '700',
    textAlign: 'center',
  },
  modalSubtitle: {
    color: appColors.text.secondary,
    fontSize: 13,
    textAlign: 'center',
  },
  infoIconSmall: {
    width: 14,
    height: 14,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: '#2d6e68',
    alignItems: 'center',
    justifyContent: 'center',
  },
  infoIconSmallText: {
    color: '#8FA08B',
    fontSize: 10,
    fontWeight: '700',
  },
  modalRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 4,
    borderBottomWidth: 1,
    borderBottomColor: appColors.border.default,
    gap: 10,
  },
  modalLabel: {
    color: appColors.text.heading,
  },
  modalLabelGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flex: 1,
  },
  modalGameIcon: {
    width: 40,
    height: 40,
    borderRadius: 4,
  },
  modalValue: {
    color: '#A1D493',
    fontWeight: '700',
  },
  modalEmpty: {
    color: '#8FA08B',
  },
  modalCloseButton: {
    marginTop: 8,
    alignSelf: 'flex-end',
    width: 30,
      height: 30,
  },
  playerBreakdownOkButton: {
    width: 80,
  },
  modalCloseButtonBlue: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: appColors.border.default,
    backgroundColor: appColors.surface.alt,
  },
  modalBackButton: {
    alignSelf: 'flex-start',
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: appColors.border.default,
    backgroundColor: appColors.surface.alt,
  },
  modalBackText: {
    color: appColors.text.heading,
    fontSize: 12,
    fontWeight: '700',
  },
  modalCloseText: {
    color: appColors.text.heading,
    fontWeight: '700',
    fontSize: 20,
    lineHeight: 20,
  },
  leaderboardChangeModalCard: {
    gap: 10,
    marginTop: 38,
    paddingTop: 30,
    borderWidth: 1,
    borderColor: appColors.accent.goldBorder,
    overflow: 'visible',
    shadowColor: appColors.accent.gold,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.45,
    shadowRadius: 26,
    elevation: 14,
  },
  leaderboardChangeBadge: {
    position: 'absolute',
    top: -38,
    alignSelf: 'center',
    width: 76,
    height: 76,
    borderRadius: 38,
    backgroundColor: appColors.accent.gold,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 3,
    borderColor: appColors.surface.base,
    shadowColor: appColors.accent.gold,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.8,
    shadowRadius: 18,
    elevation: 16,
  },
  leaderboardChangeBadgeIcon: {
    fontSize: 38,
  },
  leaderboardChangeTitle: {
    color: appColors.text.heading,
    fontSize: 22,
    fontWeight: '800',
    letterSpacing: 0.3,
    textAlign: 'center',
  },
  leaderboardChangeTitleSpark: {
    color: appColors.accent.gold,
  },
  leaderboardChangeRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: appColors.surface.alt,
    borderWidth: 1,
    borderColor: appColors.accent.subtleBorder,
    borderRadius: 12,
    paddingVertical: 11,
    paddingHorizontal: 14,
    gap: 12,
  },
  leaderboardChangeRowLeader: {
    backgroundColor: appColors.accent.goldSoft,
    borderColor: appColors.accent.goldBorder,
  },
  leaderboardChangeRankPill: {
    width: 30,
    height: 30,
    borderRadius: 9,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: appColors.surface.elevated,
  },
  leaderboardChangeRankPillLeader: {
    backgroundColor: appColors.accent.gold,
  },
  leaderboardChangeRankPillText: {
    color: appColors.text.secondary,
    fontSize: 14,
    fontWeight: '800',
  },
  leaderboardChangeRankPillTextLeader: {
    color: appColors.background.app,
  },
  leaderboardChangeArrow: {
    fontSize: 16,
    fontWeight: '800',
  },
  leaderboardChangeArrowUp: {
    color: '#A1D493',
  },
  leaderboardChangeArrowDown: {
    color: '#E58F8F',
  },
  leaderboardChangeArrowSame: {
    color: appColors.text.secondary,
  },
  leaderboardChangeName: {
    color: appColors.text.heading,
    flex: 1,
    fontWeight: '700',
    fontSize: 15,
  },
  leaderboardChangeValue: {
    color: appColors.text.secondary,
    fontWeight: '800',
    minWidth: 56,
    textAlign: 'right',
    letterSpacing: 0.4,
  },
  leaderboardChangeValueLeader: {
    color: appColors.accent.gold,
  },
  leaderboardChangeActions: {
    marginTop: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
  },
  leaderboardChangeButtonFlex: {
    flex: 1,
  },
  leaderboardChangeSecondaryButton: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: appColors.accent.subtleBorder,
    backgroundColor: appColors.surface.alt,
    paddingHorizontal: 12,
    paddingVertical: 10,
  },
  leaderboardChangePrimaryButton: {
    borderRadius: 12,
  },
  holeMenuPopupLayer: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 60,
    elevation: 12,
  },
  holeMenuPopupBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(17,44,27,0.1)',
  },
  holeMenuPopupCard: {
    position: 'absolute',
    top: 52,
    left: 12,
    maxHeight: 560,
    width: 360,
    backgroundColor: appColors.background.panel,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#1A3A20',
    paddingVertical: 8,
    ...blockShadow,
  },
  holeMenuScroll: {
    maxHeight: 500,
  },
  holeMenuScrollContent: {
    paddingTop: 4,
    paddingBottom: 4,
  },
  holeMenuRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderTopWidth: 1,
    borderTopColor: '#1A3A20',
    backgroundColor: 'transparent',
  },
  holeMenuRowCurrent: {
    backgroundColor: 'rgba(22, 163, 74, 0.2)',
  },
  holeMenuRowLeft: {
    flex: 1,
    gap: 2,
    backgroundColor: 'transparent',
  },
  holeMenuRowRight: {
    alignItems: 'flex-end',
    gap: 2,
    marginLeft: 12,
    backgroundColor: 'transparent',
  },
  holeMenuRowTitle: {
    color: '#F5F5DC',
    fontSize: 14,
    fontWeight: '700',
  },
  holeMenuCurrent: {
    color: '#A1D493',
    fontSize: 11,
    fontWeight: '700',
  },
  holeMenuStatus: {
    color: '#8FA08B',
    fontSize: 12,
  },
  holeMenuScore: {
    color: '#F5F5DC',
    fontSize: 12,
    fontWeight: '700',
  },
  gameResultsHeader: {
    borderBottomWidth: 1,
    borderBottomColor: '#1A3A20',
    paddingBottom: 2,
    marginBottom: 2,
    backgroundColor: 'transparent',
  },
  gameResultsName: {
    flex: 1.8,
    fontWeight: '700',
    fontSize: 12,
    color: '#F5F5DC',
  },
  gameResultsPlayer: {
    flex: 1,
    textAlign: 'center',
    color: '#F5F5DC',
    fontWeight: '600',
    fontSize: 12,
    backgroundColor: 'transparent',
  },
  gameResultCell: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: 2,
    paddingHorizontal: 4,
    backgroundColor: 'transparent',
  },
  gameResultValueWrapper: {
    paddingVertical: 2,
    paddingHorizontal: 6,
    backgroundColor: 'transparent',
  },
  gameResultValueContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    backgroundColor: 'transparent',
  },
  gameResultValue: {
    textAlign: 'center',
    fontWeight: '800',
    color: '#A1D493',
  },
  gameResultMedalText: {
    fontSize: 13,
    lineHeight: 16,
  },
  gameResultFishText: {
    fontSize: 12,
    lineHeight: 16,
  },
  gameResultLeaderShared: {
    borderColor: '#2d6e68',
  },
  scoreboardNameContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    backgroundColor: 'transparent',
  },
  hazardIcon: {
    width: 16,
    height: 16,
  },
  navRowBottom: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 12,
    marginTop: 12,
    backgroundColor: 'transparent',
  },
  compactGameResultsUnderNav: {
    marginTop: 12,
    backgroundColor: 'transparent',
  },
  primaryButton: {
    marginTop: 8,
    backgroundColor: '#A1D493',
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#1aa374',
  },
  primaryButtonText: {
    color: '#F5F5DC',
    fontWeight: '800',
    fontSize: 16,
    textAlign: 'center',
  },
  primaryButtonImageMode: {
    width: 220,
    height: 60,
  },
  primaryButtonImageText: {
    fontSize: 16,
  },
  compactNavButtonBlue: {
    width: 168,
    height: 52,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: appColors.border.default,
    backgroundColor: appColors.surface.alt,
  },
  compactNavBlueButtonText: {
    color: appColors.text.secondary,
    fontWeight: '700',
    fontSize: 12,
    letterSpacing: 1.8,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  compactNavButtonPrimary: {
    borderColor: appColors.accent.primary,
    backgroundColor: appColors.accent.primary,
  },
  compactNavButtonPrimaryText: {
    color: appColors.background.app,
  },
  birdieOverlay: {
    ...StyleSheet.absoluteFillObject,
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    backgroundColor: 'transparent',
    zIndex: 9999,
    elevation: 9999,
    alignItems: 'center',
    justifyContent: 'center',
  },
  birdieImage: {
    width: 300,
    height: 300,
  },
});
